import type { ReactNode } from "react";

interface SettingsRowProps {
  label: string;
  description?: string;
  /** The control or value on the right. */
  children?: ReactNode;
}

/** One line inside a `SettingsSection`. */
export function SettingsRow({ label, description, children }: SettingsRowProps) {
  return (
    <div className="flex items-center justify-between gap-4 border-b border-border px-5 py-4 last:border-b-0">
      <div className="min-w-0">
        <div className="font-medium text-text">{label}</div>
        {description !== undefined && (
          <div className="mt-0.5 text-sm text-text-muted">{description}</div>
        )}
      </div>
      {children}
    </div>
  );
}
